module.exports = __webpack_public_path__ + "img/gift-box-white.cc711647.svg";